import Vue, { VueConstructor } from 'vue';
import VueRouter from 'vue-router';
import { RouteConfig, RouterOptions } from 'vue-router';

import store from '@/store/Store';
import sidebarRoutes from './navbarRoutes';
import AppMain from '@/components/main/AppMain.vue';
import LoginPage from '@/components/auth/LoginPage.vue';
import NotFoundPage from '@/components/main/NotFoundPage.vue';

Vue.use(VueRouter);

let entryUrl: string | null = null;

const routes: RouteConfig[] = [
  {
    path: '/',
    component: AppMain as VueConstructor, // https://github.com/vuejs/composition-api/issues/130
    redirect: '/products',
    children: [...sidebarRoutes],
  },
  {
    path: '/login',
    component: LoginPage as VueConstructor,
    children: [...sidebarRoutes],
  },
  {
    path: '/*',
    component: AppMain as VueConstructor,
    children: [
      {
        path: `/*`,
        component: NotFoundPage as VueConstructor,
        name: 'Not Found',
        meta: {
          title: 'NotFound',
          icon: 'mdi-sim-off',
          isSidebarItem: false,
        },
      },
      ...sidebarRoutes,
    ],
  },
];

const router = new VueRouter({
  routes: routes,
} as RouterOptions);

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title + ' | Admin Panel';

  /**
   * Redirect to Login page if not logged in,
   * after login redirect to original page
   */
  if (to.path !== '/login') {
    store.dispatch('userModule/checkAuth', null, { root: true }).then(res => {
      if (res) {
        if (entryUrl) {
          const url = entryUrl;
          entryUrl = null;
          return next(url);
        } else {
          return next();
        }
      } else {
        entryUrl = to.path;
        next('/login');
      }
    });
  } else {
    store.dispatch('userModule/checkAuth', null, { root: true }).then(res => {
      if (res) next('/products');
      else next();
    });
  }
});

export default router;
